import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CertificateService from "../../services/CertificateService";

let initialState = {
    certificates: [],
    certificateTemplates: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllCertificates = createAsyncThunk(
    'getAllCertificates',
    async ({page, limit, username, issueDate, signed, categoryId}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await CertificateService.getAllCertificates(page, limit, username, issueDate, signed, categoryId);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

export const getAllCertificateTemplates = createAsyncThunk(
    'getAllCertificateTemplates',
    async ({page, limit}, {getState, rejectWithValue, dispatch}) => {
        try {
            const response = await CertificateService.getAllCertificateTemplates(page, limit);
            return response;
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const certificateListSlice = createSlice({
    name: 'certificateListSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllCertificates.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllCertificates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.certificates = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllCertificates.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.certificates = [];
                state.hasMore = false;
            })
            .addCase(getAllCertificateTemplates.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllCertificateTemplates.fulfilled, (state, action) => {
                state.isLoading = false;
                state.certificateTemplates = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllCertificateTemplates.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.certificateTemplates = [];
                state.hasMore = false;
            })
    }
});

export const {} = certificateListSlice.actions;

export default certificateListSlice.reducer;